export default __webpack_public_path__ + "static/media/africa_achievement.2fc78494.png";